import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 16px;
  flex-wrap: wrap;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: end;
  flex-wrap: wrap;
  flex: 1;
`;

export const FilterButtonWrapper = styled.div`
  display: flex;
  align-items: end;
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 75px);
  padding: 24px;
  padding-bottom: 90px;
  background: var(--color-contrast-white);
  overflow-y: auto;
`;

export const FilterHeader = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 24px 0;
  color: var(--color-text-primary);
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const FilterActions = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: space-around;
  border-top: solid var(--color-neutral-300) 1px;
  padding: 15px 24px;
  background: var(--color-contrast-white);
  margin-bottom: 24px;

  button {
    width: 200px;
  }
`;

export const SidebarWrapper = styled.div`
  .daily-delivery-sidebar {
    top: 45px !important;
    height: calc(100vh - 45px) !important;
    
    > div:last-child {
      top: 45px !important;
    }
  }
`;
